import React, { useState, useEffect, useLayoutEffect } from 'react';
import BtnSubmitTest from '../components/BtnSubmitTest';
import Video from '../components/Video';
import AnswerAlternativeListItem from '../components/AnswerAlternativeListItem.js';

import lacapiProxy from '../libs/lacapi';

const Question = props => {

	const [questionIndex, setQuestionIndex] = useState();
	const [filledInAllAnswers, setFilledInAllAnswers] = useState(false);
	const [errorState, setErrorSate] = useState(false);

	useEffect(() => {
		window.scrollTo(0, 0);

	}, []);

	useLayoutEffect(() => {
		setFilledInAllAnswers(checkForComplete());
	});
	
	const showQuestion = event => {
		let i = parseInt(event.target.id);
		setQuestionIndex(i);
	};

	const hideQuestion = () => {
		setQuestionIndex(null);
	}

	const temporaryAnswer = event => {
		props.questions[questionIndex].temporaryAnswer = event.currentTarget.id;
		props.questions[questionIndex].temporaryAnswerIndex = event.currentTarget.getAttribute("index");
		if (checkForComplete()) {
			setFilledInAllAnswers(true);
		}
		if (errorState) {
			hideQuestion();

		} else {
			handleIncrement();
		}
	};

	const handleIncrement = (prevState) => {
		setQuestionIndex(questionIndex + 1);
	}

	const checkForComplete = () => {

		for (let question of props.questions) {
			if (!question.hasOwnProperty("temporaryAnswer")) {
				return false;
			}
		}
		return true;
	}

	const completeTest = () => {
		if (!filledInAllAnswers) {
			setErrorSate(true);
			alert("Du måste fylla i alla svar för att skicka in dina svar.");
			setQuestionIndex(null);
		} else {
			var answers = [];

			for (let question of props.questions) {
				answers.push({ "questionId": parseInt(question.id.toString()), "answerId": parseInt(question.temporaryAnswerIndex.toString()) })
			}

			lacapiProxy.saveQuestionAnswers(props.courseId, props.user.id, answers).then(() => {
				window.location.reload();
			});
		}
	}

	return (
		<div className="question-wrapper">
			<div className="white-background">
				<main>
					{!props.loaded ? (
						<div className="loader-container">
							<div className="dash uno"></div>
							<div className="dash dos"></div>
							<div className="dash tres"></div>
							<div className="dash cuatro"></div>
						</div>
					) : (
							<div className="flex-wrapper">
								<div className="flex-left">
									<Video errorState={errorState} filledInAllAnswers={filledInAllAnswers} />

									<p style={{ fontStyle: 'italic' }}>Du måste fylla i alla svar för att kunna skicka in dina svar.</p>
									{errorState && !filledInAllAnswers ? <p style={{ color: 'red' }}>Frågor markerat med rött visar på dom du inte svarat på.</p> : ''}
								</div>
								<div className="flex-right">
									{props.questions.map((question, i) => {
										let thisQuestionIndex = i + 1;
										if (questionIndex == i) {
											return (
												<div className="accordion-expanded" key={i}>
													<div className="accordion-description" onClick={hideQuestion}>
														<h2 className="accordion-heading" id={question.id}>{thisQuestionIndex + ". " + question.title}</h2>
														<p>
															{question.text}
														</p>
													</div>

													<div className="one-question">
														<div className="question-answers">
															<ul>
																{question.answers.map((answer, i) => {
																	return (
																		<AnswerAlternativeListItem
																			key={i}
																			index={i}
																			id={answer.id}
																			answer={answer}
																			temporaryAnswer={temporaryAnswer}
																			chosen={question.temporaryAnswerIndex == i}
																		/>
																	);
																})}
															</ul>
														</div>
													</div>
												</div>
											);
										} else {
											return (
												<div onClick={showQuestion} key={i} id={i} className={"accordion-small " + (!question.temporaryAnswerIndex && errorState ? 'not-answered' : '')} >
													<h2 className="accordion-heading" id={i}>{thisQuestionIndex + ". " + question.title}</h2>
													<span className="chosen-answer">{question.temporaryAnswerIndex}</span>
												</div>
											);
										}
									})}
								</div>

							</div>
						)}

					<nav className="btn-wrapper">
						<div className="btn-prev-div">
							<a onClick={() => props.setStarted(false)}>Till introduktionen</a>
						</div>

						<div className="btn-center-wrapper">
							<BtnSubmitTest
								filledInAllAnswers={filledInAllAnswers}
								completeTest={completeTest}
							/>
						</div>
					</nav>
				</main>

				<div className="pink-circle"></div>
			</div>
		</div>
	);
}

export default Question;



// WEBPACK FOOTER //
// ./src/pages/QuestionPage.js